import lodash from 'lodash';

import {STENCILCONST} from './constant.js.erb';

const textBody = ''
const textFont = 'caslon'
const textFontClass = 'font-caslon'
const textHeight = 3
const textSpacing = 100
const textWidth = 20
const materialWidth = 126
const textAlign = 'center'
const quantity = 1
const material = 'Medium-Duty 10 mil film'

const oldTab = 0
const activeTab = 0

const totalPrice = 1
const approved = false

const state = {
  textBody,
  textFont,
  textFontClass,
  textHeight,
  textSpacing,
  textWidth,
  textAlign,
  materialWidth,
  quantity,
  material,
  oldTab,
  activeTab,
  totalPrice,
  approved,
  instructions : "",
  requiresEmailPreview : "No",
  fontData : null,
  products : [],
  materials : [],
  fonts : [],
  discountSchedule : {},
  discountTexts : ""
}

const mutations = {
  setTextBody : (state, payload) => state.textBody = payload,
  setTextFont : (state, payload) => state.textFont = payload,
  setTextFontClass : (state, payload) => state.textFontClass = payload,
  setTextHeight : (state, payload) => state.textHeight = payload,
  setTextSpacing : (state, payload) => state.textSpacing = payload,
  setTextAlign : (state, payload) => state.textAlign = payload,
  setQuantity : (state, payload) => state.quantity = payload,
  setMaterial : (state, payload) => state.material = payload,
  setMaterialWidth : (state, payload) => state.materialWidth = payload,
  setOldTab : (state, payload) => state.oldTab = payload,
  setActiveTab : (state, payload) => state.activeTab = payload,
  setTotalPrice : (state, payload) => state.totalPrice = payload,
  setApproved : (state, payload) => state.approved = payload,
  setInstructions : (state, payload) => { state.instructions = payload },
  setRequiresEmailPreview :
      (state, payload) => { state.requiresEmailPreview = payload },
  setFontData : (state, payload) => { state.fontData = payload },
  setProducts : (state, products) => { state.products = products },
  setMaterials : (state, materials) => { state.materials = materials },
  setFonts : (state, fonts) => { state.fonts = fonts },
  setFontSizes : (state, font_sizes) => { state.font_sizes = font_sizes },
  setBorderRules : (state, rules) => { state.borderRules = rules },
  setDiscountSchedule :
      (state,
       discount_schedule) => { state.discountSchedule = discount_schedule },
  setDiscountTexts :
      (state, discount_texts) => { state.discountTexts = discount_texts }
}

function round(num) { return Math.round(num * 100) / 100; }

const DISPLAY_FONT_HEIGHT = 144;

const getters = {
  /*
  ** Capitalized "ABC" is the reference text we use to define the nominal
  ** text height.
  */
  referenceTextPath : (state) => {
    if (state.fontData) {
      return state.fontData.getPath('ABC', 0, 0, DISPLAY_FONT_HEIGHT);
    }
  },
  /*
   * The reference height is an integer that equals in inches
   * whichever font height the user chose. It is used as a starting
   * point to convert from integer units into inches.
   */
  referenceTextHeight : (state, getters) => {
    if (getters.referenceTextPath) {
      const {y1, y2} = getters.referenceTextPath.getBoundingBox();
      return Math.abs(y2 - y1)
    } else {
      return 1;
    }
  },
  textWidthInInches : (state, getters) => {
    return round(getters.widthAsFractionOfReference * state.textHeight);
  },
  textHeightInInches : (state, getters) => {
    return round(getters.heightAsFractionOfReference * state.textHeight);
  },
  widthAsFractionOfReference : (state, getters) => {
    return getters.viewBoxWidth / getters.referenceTextHeight;
  },
  heightAsFractionOfReference : (state, getters) => {
    return getters.viewBoxHeight / getters.referenceTextHeight;
  },
  viewBoxWidth : (state, getters) => {
    if (getters.boundingBox) {
      const {x1, x2} = getters.boundingBox;
      return Math.abs(x1 - x2);
    }
  },
  viewBoxHeight : (state, getters) => {
    if (getters.boundingBox) {
      const {y1, y2} = getters.boundingBox;
      return Math.abs(y1 - y2);
    }
  },
  /*
   * Combined bounding box of all paths:
   * Smallest (x1, y1) and largest (x2, y2)
   */
  boundingBox : (state, getters) => {
    const reducer = (acc, path) => {
      const bb = path.getBoundingBox();

      return {
        x1 : Math.min(acc.x1, bb.x1),
        y1 : Math.min(acc.y1, bb.y1),
        x2 : Math.max(acc.x2, bb.x2),
        y2 : Math.max(acc.y2, bb.y2)
      };
    };

    return getters.svgPaths.reduce(reducer, {x1 : 0, y1 : 0, x2 : 0, y2 : 0});
  },
  lineHeight : (state, getters) => {
    switch (state.textFont) {
    case "se-parking-lot":
      return 1.33;
    case "se-military":
      return 1.33;
    case "stencil":
      return 1.33;
    default:
      return 1.5;
    }
  },
  svgPaths : (state, getters) => {
    if (state.fontData) {
      const lines = state.textBody.split("\n");
      const line_spacing = getters.referenceTextHeight * getters.lineHeight;

      return lines.map((line, i) => state.fontData.getPath(
                           line, 0, i * line_spacing, DISPLAY_FONT_HEIGHT));
    } else {
      return [];
    }
  },
  borderSpacing : (state, getters) => {
    const fontHeight = state.textHeight;
    const activeRule = lodash.chain(state.borderRules)
                           .sortBy('start')
                           .takeWhile(rule => rule.start < fontHeight)
                           .last()
                           .defaultTo({border : 2})
                           .value();
    return activeRule.border;
  },
  materialWidth : (state, getters) => {
    return getters.textWidthInInches + getters.borderSpacing * 2;
  },
  materialHeight : (state, getters) => {
    return getters.textHeightInInches + getters.borderSpacing * 2;
  },
  discountSchedule : (state, getters) => {
    return state.discountSchedule[state.material] ||
           state.discountSchedule["default"] || {};
  }
};

const actions = {
  SET_FONT_DATA : ({commit}, payload) => commit('setFontData', payload),
  SET_TEXT : ({commit}, payload) => commit('setTextBody', payload),
  SET_TEXT_FONT : ({commit, dispatch}, font_id) => {
    let font = STENCILCONST.fontInfo.find(font => font.id == font_id);

    if (font) {
      commit('setTextFont', font_id);
      dispatch("LOAD_FONT", font_id);
    } else {
      console.log(`Couldn't switch to font ${font_id}`);
    }
  },
  SET_FONT_CLASS : ({commit}, payload) => commit('setTextFontClass', payload),
  SET_HEIGHT : ({commit}, payload) => commit('setTextHeight', payload),
  SET_SPACING : ({commit}, payload) => commit('setTextSpacing', payload),
  SET_ALIGN : ({commit}, payload) => commit('setTextAlign', payload),
  SET_QUANTITY : ({commit}, payload) => commit('setQuantity', payload),
  SET_MWIDTH : ({commit}, payload) => commit('setMaterialWidth', payload),
  SET_MATERIAL : ({commit}, payload) => commit('setMaterial', payload),
  SET_OLDTAB : ({commit}, payload) => commit('setOldTab', payload),
  SET_ACTIVETAB : ({commit}, payload) => commit('setActiveTab', payload),
  SET_TOTALPRICE : ({commit}, payload) => commit('setTotalPrice', payload),
  SET_APPROVED : ({commit}, payload) => commit('setApproved', payload),
  SET_INSTRUCTIONS :
      ({commit}, payload) => { commit('setInstructions', payload) },
  SET_REQUIRES_EMAIL_PREVIEW :
      ({commit}, payload) => { commit('setRequiresEmailPreview', payload) },
  SET_PRODUCTS :
      ({commit, state}, products) => { commit('setProducts', products) },
  SET_MATERIALS :
      ({commit, state}, materials) => { commit('setMaterials', materials) },
  SET_FONTS : ({commit, dispatch}, fonts) => {
    const first_font_id = fonts.map(font => font.id).sort()[0];
    commit('setFonts', fonts);
    dispatch('SET_TEXT_FONT', first_font_id);
  },
  SET_FONT_SIZES :
      ({commit, state}, font_sizes) => { commit('setFontSizes', font_sizes) },

  LOAD_FONT : ({commit, dispatch}, font_id) => {
    const font = STENCILCONST.fontInfo.find(font => font.id == font_id)
    let url;

    if (font) {
      url = font.filename;
    } else {
      url = STENCILCONST.fontInfo[0].filename;
    }

    opentype.load(url, function(err, data) {
      if (err) {
        console.log("There was an error loading the font");
      } else {
        commit("setFontData", data);
      }
    });
  },
  SET_BORDER_RULES : ({commit}, rules) => { commit('setBorderRules', rules); },
  SET_DISCOUNT_SCHEDULE : ({commit}, discount_schedule) => {
    commit('setDiscountSchedule', discount_schedule);
  },
  SET_DISCOUNT_TEXTS :
      ({commit},
       discount_texts) => { commit('setDiscountTexts', discount_texts); }
}

export default {
  namespaced: true, state, mutations, actions, getters
}
